// @flow
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { getSelectedBusinessUnit } from 'common/redux/selectors/intl';

import { BusinessUnit } from 'common/models/internal/BusinessUnits';

const useSelectedBU = (): ?BusinessUnit => {
    const match = useRouteMatch();
    return useSelector(state => getSelectedBusinessUnit(state, { match }));
};

export default useSelectedBU;
